import actionTypes from '../actionTypes';
import { selectedHierarchyRhId } from '../utils.js';

const initialState = {
	hierarchy: [],
	hierarchyModalOpen: false,
	hierarchyLoading: false,
	hierarchyErrorCode: 0,
	hierarchyFilterRhid: '',
	applyBtnView: false,

	savedHierarchy: [],
	savedHierarchyLoading: false,
	savedHierarchyErrorCode: 0,
	searchedHierarchy: [],

	saveHierarchyStatusCode: 0,

	deleteSavedHierarchyLoading: false,
	deleteSavedHierarchyErrorCode: 0,

	editSavedHierarchyLoading: false,
	editSavedHierarchyErrorCode: 0,
	editSavedHierarchyErrorMsg: null,

	isEditFlow: false,
	editHierarchy: null,

	selectedHierarchy: {
		name: 'All Departments and Categories',
		hierarchyFilterRhId: '',
	},

	editSelectedHierarchy: false,

	validateHierarchyErrorCode: 0,
	validateHierarchyErrorMsg: null,
	validateHierarchyErrorMsgCode: 0,

	updateSavedHierarchyErrorCode: 0,
	updateSavedHierarchyDefaultValue: null,

	validateHierarchyLoading: false,

	errorDialog: false,
	errorCode: 0,
};

const getAllDeptRhids = (data) => {
	let rhid = '';
	data?.forEach((dept) => {
		rhid += dept?.id + ',';
	});

	return rhid.slice(0, -1);
};

const getSelectedHierarchy = (bussinessHierarchyResponse, SavedHierachyArr) => {
	if (SavedHierachyArr?.length > 0) {
		const defaultHierarchy = SavedHierachyArr.find(
			(hierarchy) => hierarchy?.isDefault === true
		);
		if (defaultHierarchy) {
			return {
				name: defaultHierarchy?.name,
				hierarchyFilterRhId: selectedHierarchyRhId(defaultHierarchy),
			};
		}
	}
	return {
		name: 'All Departments and Categories',
		hierarchyFilterRhId: getAllDeptRhids(bussinessHierarchyResponse),
	};
};

const fullCompanyViewReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		case actionTypes.GET_BUSINESS_HIERARCHY: {
			return {
				...state,
				hierarchyLoading: true,
			};
		}
		case actionTypes.GET_BUSINESS_HIERARCHY_SUCCESS: {
			return {
				...state,
				hierarchyLoading: false,
				hierarchy: action.payload?.data,
				hierarchyErrorCode: 0,
			};
		}
		case actionTypes.GET_BUSINESS_HIERARCHY_FAILURE: {
			return {
				...state,
				hierarchyLoading: false,
				hierarchy: [],
				hierarchyErrorCode: action?.payload,
				errorDialog: true,
				errorCode: 1001,
			};
		}
		case actionTypes.GET_SAVED_HIERARCHY: {
			return {
				...state,
				savedHierarchyLoading: true,
			};
		}
		case actionTypes.GET_SAVED_HIERARCHY_SUCCESS: {
			return {
				...state,
				savedHierarchyLoading: false,
				savedHierarchy:
					action.payload?.savedHierarchyResponse?.insightPreferences,
				selectedHierarchy: getSelectedHierarchy(
					action?.payload?.bussinessHierarchyResponse?.data,
					action?.payload?.savedHierarchyResponse?.insightPreferences
				),
				hierarchyFilterRhid: getAllDeptRhids(
					action?.payload?.bussinessHierarchyResponse?.data
				),
				savedHierarchyErrorCode: 0,
			};
		}
		case actionTypes.GET_SAVED_HIERARCHY_FAILURE: {
			return {
				...state,
				errorDialog: true,
				errorCode: 1002,
				savedHierarchyLoading: false,
				savedHierarchyErrorCode: action?.payload?.statusCode,
				hierarchyFilterRhid: getAllDeptRhids(
					action?.payload?.bussinessHierarchyResponse?.data
				),
			};
		}
		case actionTypes.SAVE_HIERARCHY: {
			return {
				...state,
				saveHierarchyStatusCode: 0,
			};
		}
		case actionTypes.SAVE_HIERARCHY_SUCCESS: {
			return {
				...state,
				savedHierarchy: action?.payload?.json?.insightPreferences,
				saveHierarchyStatusCode: action?.payload?.statusCode,
			};
		}
		case actionTypes.SAVE_HIERARCHY_FAILURE: {
			return {
				...state,
				saveHierarchyStatusCode: action?.payload?.statusCode,
			};
		}
		case actionTypes.SAVE_SEARCHED_HEIRARCHY: {
			return {
				...state,
				searchedHierarchy: action?.payload,
			};
		}
		case actionTypes.CLEAR_SEARCHED_HEIRARCHY: {
			return {
				...state,
				searchedHierarchy: action?.payload,
			};
		}
		case actionTypes.SAVE_HIERARCHY_FILTER: {
			return {
				...state,
				hierarchyFilterRhid: action?.payload,
			};
		}
		case actionTypes.OPEN_HIERARCHY_MODAL: {
			return {
				...state,
				hierarchyModalOpen: action?.payload,
			};
		}
		case actionTypes.CLICK_APPLY: {
			return {
				...state,
				applyBtnView: action?.payload,
			};
		}
		case actionTypes.DELETE_SAVED_HIERARCHY: {
			return {
				...state,
				deleteSavedHierarchyLoading: true,
				deleteSavedHierarchyErrorCode: 0,
			};
		}
		case actionTypes.DELETE_SAVED_HIERARCHY_SUCCESS: {
			return {
				...state,
				savedHierarchy: action?.payload?.json?.insightPreferences,
				deleteSavedHierarchyLoading: false,
				deleteSavedHierarchyErrorCode: action.payload?.statusCode,
			};
		}
		case actionTypes.DELETE_SAVED_HIERARCHY_FAILURE: {
			return {
				...state,
				deleteSavedHierarchyLoading: false,
				deleteSavedHierarchyErrorCode: action?.payload?.statusCode,
			};
		}
		case actionTypes.EDIT_SAVED_HIERARCHY: {
			return {
				...state,
				editSavedHierarchyLoading: true,
				editSavedHierarchyErrorCode: 0,
				editSavedHierarchyErrorMsg: null,
			};
		}
		case actionTypes.EDIT_SAVED_HIERARCHY_SUCCESS: {
			return {
				...state,
				savedHierarchy: action?.payload?.json?.insightPreferences,
				editSavedHierarchyErrorCode: action?.payload?.statusCode,
				editSavedHierarchyLoading: false,
			};
		}
		case actionTypes.EDIT_SAVED_HIERARCHY_FAILURE: {
			return {
				...state,
				editSavedHierarchyLoading: false,
				editSavedHierarchyErrorCode: action?.payload?.statusCode,
				editSavedHierarchyErrorMsg: action?.payload?.json?.error,
			};
		}
		case actionTypes.SET_SELECTED_HIERARCHY: {
			return {
				...state,
				selectedHierarchy: action?.payload,
			};
		}
		case actionTypes.SET_EDIT_FLOW: {
			return {
				...state,
				isEditFlow: action?.payload,
			};
		}
		case actionTypes.SET_HIERRCHY_FILTER_RHID: {
			return {
				...state,
				hierarchyFilterRhid: action?.payload,
			};
		}
		case actionTypes.SET_EDIT_HIERARCHY: {
			return {
				...state,
				editHierarchy: action?.payload,
				editSavedHierarchyErrorCode: 0,
			};
		}
		case actionTypes.VALIDATE_HIERARCHY: {
			return {
				...state,
				validateHierarchyErrorCode: 0,
				validateHierarchyErrorMsg: null,
				validateHierarchyErrorMsgCode: 0,
				validateHierarchyLoading: true,
			};
		}
		case actionTypes.VALIDATE_HIERARCHY_SUCCESS: {
			return {
				...state,
				validateHierarchyErrorCode: 0,
				validateHierarchyErrorMsg: null,
				validateHierarchyErrorMsgCode: 0,
				validateHierarchyLoading: false,
			};
		}
		case actionTypes.VALIDATE_HIERARCHY_FAILURE: {
			return {
				...state,
				validateHierarchyErrorCode: action?.payload?.statusCode,
				validateHierarchyErrorMsg: action?.payload?.json?.error,
				validateHierarchyErrorMsgCode: action?.payload?.json?.errorCode,
				validateHierarchyLoading: false,
			};
		}
		case actionTypes.RESET_VALIDATE_HIERARCHY: {
			return {
				...state,
				validateHierarchyErrorCode: 0,
				validateHierarchyErrorMsg: null,
				editSavedHierarchyErrorCode: 0,
				editSavedHierarchyErrorMsg: null,
				validateHierarchyErrorMsgCode: 0,
				updateSavedHierarchyDefaultValue: null,
				updateSavedHierarchyErrorCode: 0,
				deleteSavedHierarchyErrorCode: 0,
				saveHierarchyStatusCode: 0,
				validateHierarchyLoading: false,
			};
		}
		case actionTypes.UPDATE_SAVED_HIERARCHY: {
			return {
				...state,
				updateSavedHierarchyErrorCode: 0,
				updateSavedHierarchyDefaultValue: null,
			};
		}
		case actionTypes.UPDATE_SAVED_HIERARCHY_SUCCESS: {
			return {
				...state,
				updateSavedHierarchyErrorCode: action?.payload?.statusCode,
				updateSavedHierarchyDefaultValue: action?.payload?.value,
				savedHierarchy: action.payload?.json?.insightPreferences,
			};
		}
		case actionTypes.UPDATE_SAVED_HIERARCHY_FAILURE: {
			return {
				...state,
				updateSavedHierarchyErrorCode: action?.payload?.statusCode,
			};
		}
		case actionTypes.EDIT_SELECTED_HIERARCHY: {
			return {
				...state,
				editSelectedHierarchy: action?.payload,
			};
		}
		case actionTypes.GET_USER_AUTH_FAILURE: {
			return {
				...state,
				errorDialog: true,
				errorCode: 1003,
			};
		}
		case actionTypes.RESET_FULL_COMPANY_VIEW_REDUCER: {
			return {
				...state,
				hierarchy: [],
				hierarchyModalOpen: false,
				hierarchyLoading: false,
				hierarchyErrorCode: 0,
				hierarchyFilterRhid: '',
				applyBtnView: false,

				savedHierarchy: [],
				savedHierarchyLoading: false,
				savedHierarchyErrorCode: 0,
				searchedHierarchy: [],

				saveHierarchyStatusCode: 0,

				deleteSavedHierarchyLoading: false,
				deleteSavedHierarchyErrorCode: 0,

				editSavedHierarchyLoading: false,
				editSavedHierarchyErrorCode: 0,
				editSavedHierarchyErrorMsg: null,

				isEditFlow: false,
				editHierarchy: null,

				selectedHierarchy: {
					name: 'All Departments and Categories',
					hierarchyFilterRhId: '',
				},

				editSelectedHierarchy: false,

				validateHierarchyErrorCode: 0,
				validateHierarchyErrorMsg: null,
				validateHierarchyErrorMsgCode: 0,

				updateSavedHierarchyErrorCode: 0,
				updateSavedHierarchyDefaultValue: null,

				validateHierarchyLoading: false,

				errorDialog: false,
			};
		}
		default:
			return state;
	}
};

export default fullCompanyViewReducer;
